import { gql } from '@apollo/client';

export default gql`
  type LocalGeoParam {
    distance: Int
    latitude: Int
    longitude: Int
  }

  # type LocalFilterParam {
  #   operator: FilterOperator
  #   field: String
  #   filters: [LocalFilterParam!]
  #   strVal: String
  #   intVal: Int
  #   boolVal: Boolean
  #   strVals: [String!]
  #   intVals: [Int!]
  #   # geoParam: LocalGeoParam
  # }
`;
